var React = require('react');

function CameraPolaroid (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M570.63 343.94L512 256V80a48 48 0 0 0-48-48H112a48 48 0 0 0-48 48v176L5.38 343.94A31.8 31.8 0 0 0 1.57 352h572.86a32.12 32.12 0 0 0-3.8-8.06zM288 256a64 64 0 1 1 64-64 64.1 64.1 0 0 1-64 64zm152-112a8 8 0 0 1-8 8h-32a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M574.43 352H1.57A31.76 31.76 0 0 0 0 361.69V448a32 32 0 0 0 32 32h512a32 32 0 0 0 32-32v-86.31a31.76 31.76 0 0 0-1.57-9.69zM480 408a8 8 0 0 1-8 8H104a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h368a8 8 0 0 1 8 8zM288 256a64 64 0 1 0-64-64 64.1 64.1 0 0 0 64 64z","className":"fa-primary","key":2})]);
}

CameraPolaroid.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = CameraPolaroid;

CameraPolaroid.default = CameraPolaroid;
